RivalIQ.apps.Reports.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'reports',
            widgetId: widgetTypes.REPORT_CENTER
        }
    ];

    const Dashboard = RivalIQ.apps.Dashboard;
    curations.ReportCenter = Dashboard.models.Curation.extend({
        title: 'Downloads',
        widgetsView: Dashboard.views.Widgets.extend({
            getChildView: function (child) {
                return child.getDetailWrapperView();
            }
        }),
        page: RivalIQ.configuration.menus.getConfiguration().REPORT_CENTER,
        widgetDefinitions: widgets,
        timePeriod: false,
        companySets: false
    });
});
